import $ from "jquery";

export const font_size_fn = function() {
    // console.log('font_size_ori');
    if ($('.font_size_ori').length == 0) return;

    const winW = $(window).width();
    const fontsize = $('.fontsize');
    const plus = $('.font_size_plus');
    const minus = $('.font_size_minus');
    const ori = $('.font_size_ori');
    let _this, fz, _fz;
    let num = 0;
    // let ori_fz = 16;
    // if (winW <= 950) ori_fz = 10;
    // if (winW <= 480) ori_fz = 12.65;
    fontsize.each(function(ind, obj) {
        _this = $(obj);
        fz = _this.css('font-size');
        // _fz = Math.round(parseFloat(fz)) / ori_fz + 'rem';
        _this.attr('ori', fz);
    });
    plus.click(function() {
        fontsize.each(function(ind, obj) {
            _this = $(obj);
            fz = _this.css('font-size');
            // _fz = (Math.round(parseFloat(fz)) + 1) / ori_fz + 'rem';
            _fz = (Math.round(parseFloat(fz)) + 1) + 'px';
            _this.css('font-size', _fz);
        });
        if (num < 3) {
            num++;
            minus.attr('disabled', false);
        } else {
            num++;
            $(this).attr('disabled', true);
        }
    });
    minus.click(function() {
        fontsize.each(function(ind, obj) {
            _this = $(obj);
            fz = _this.css('font-size');
            // _fz = (Math.round(parseFloat(fz)) - 1) / ori_fz + 'rem';
            _fz = (Math.round(parseFloat(fz)) - 1) + 'px';
            _this.css('font-size', _fz);
        });
        if (num > -3) {
            num--;
            plus.attr('disabled', false);
        } else {
            num--;
            $(this).attr('disabled', true);
        }
    });
    ori.click(function() {
        fontsize.each(function(ind, obj) {
            _this = $(obj);
            _fz = _this.attr('ori');
            _this.css('font-size', _fz);
        });
        num = 0;
        minus.attr('disabled', false);
        plus.attr('disabled', false);
    });
};